// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"99":"LazyGoogleOneTap","873":"LazyIdentificationForm"}[chunkId] + "." + {"99":"89b21afb0b7fe43c2cbb","873":"45e92539073d252ce83b"}[chunkId] + ".js";
};